angular
    .module('annexaApp')
    .component('annexaScanDocument',{
        templateUrl: './components/doc/annexa-scan-document/annexa-scan-document.html',
        controller: ['$scope', 'DccumentsFactory', '$filter', '$http', '$rootScope', 'CommonService', function($scope, DccumentsFactory, $filter, $http, $rootScope, CommonService) {
            var vm = this;
            var removeDivChilds = function(){
            	var divScan = angular.element("#scanDocumentShowFile");
            	if(divScan.length > 0){
            		divScan[0].replaceChildren();
            	}
            }
            
            var addDivChilds = function(){
            	var divScan = angular.element("#scanDocumentShowFile");
            	if(divScan.length > 0 && vm.data && vm.data.value && vm.data.value.fileBase64){
            		var obj = document.createElement('object'); 
            		obj.style.width = '100%';
            		obj.style.height = '600px';
            		obj.type = 'application/pdf';
            		obj.data = 'data:application/pdf;base64,' + vm.data.value.fileBase64;
            		divScan[0].appendChild(obj);
            	}
            }
            
            vm.scanDocument = function(){
            	$rootScope.loading(true);
            	removeDivChilds();
            	if($rootScope.app.configuration.scanConfiguration && $rootScope.app.configuration.scanConfiguration.active && $rootScope.app.configuration.scanConfiguration.url) {
            		var callScan = function(url){
	            		fetch(url, {method: "POST"}).then(function(response) {
	            			if (response.ok) {
	                            response.json().then(function(body){
	                            	vm.data.value = body;
	                            	vm.data.error = "";
	                            	addDivChilds();
	            				}).catch(function(error) {
	                    			vm.data.error = "500 Internal error";
	                    			vm.data.value = undefined;
	                    		}).finally(function () {
	                    			$rootScope.loading(false);
	                    			$scope.$apply();
	                    		});
	                        } else {
	            				response.text().then(function(data){
	            					vm.data.value = undefined;
	                				vm.data.error = data;
	            				}).catch(function(error) {
	                    			vm.data.error = "500 Internal error";
	                    			vm.data.value = undefined;
	                    		}).finally(function () {
	                    			$rootScope.loading(false);
	                    			$scope.$apply();
	                    		});
	                        }
	            		}).catch(function(error) {
	            			vm.data.error = "500 Internal error";
	            			vm.data.value = undefined;
	            			$rootScope.loading(false);
	            			$scope.$apply();
	            		});
            		}
            		var userId = (($rootScope.LoggedUser && $rootScope.LoggedUser.id)?$rootScope.LoggedUser.id:-1);
            		CommonService.getUserNameAndIdentification(userId).then(function(response) {
                		var url = $rootScope.app.configuration.scanConfiguration.url;
                		var params = "";
                		if($rootScope.app.configuration.scanConfiguration.parameters){
                			if($rootScope.app.configuration.scanConfiguration.parameters.param1 && $rootScope.app.configuration.scanConfiguration.parameters.param1 === "user" && response && response.name){
                				var userStr = "";
                				params = "?user="+btoa(response.name);
                			}
                			//Els altres tres parametres no s'utilitzen ara mateix.
//                			if($rootScope.app.configuration.scanConfiguration.parameters.param2 && $rootScope.app.configuration.scanConfiguration.parameters.param2 === "origen"){
//                			}
//    						if($rootScope.app.configuration.scanConfiguration.parameters.param3 && $rootScope.app.configuration.scanConfiguration.parameters.param3 === "docType"){
//    						}
//    						if($rootScope.app.configuration.scanConfiguration.parameters.param4 && $rootScope.app.configuration.scanConfiguration.parameters.param4 === "prodStatus"){
//    						}
                		}
                		callScan(url+params);
            		}).catch(function(error) {
                		var url = $rootScope.app.configuration.scanConfiguration.url;
                		callScan(url);
            		});
            	}else{
            		vm.data.error = $filter('translate')('global.literals.getScannerDisabled');
            		vm.data.value = undefined;
            		$rootScope.loading(false)
            		$scope.$apply();
            	}
            }
           
            this.$onInit = function () {
            	if(vm.data && vm.data.value && vm.data.value.fileBase64){
            		addDivChilds();
            	}
            }
        }],
        bindings: {
            data: '='
        }
    })